const { SET_IS_SAFARI } = require("./constants");

const initStat = {
  isSafari: false,
};

const browserReducer = (state = initStat, action) => {
  switch (action.type) {
    case SET_IS_SAFARI:
      return {
        ...state,
        isSafari: action.payload,
      };
    default:
      return state;
  }
};

export default browserReducer;
